export interface TransactionMutationPayload {
  account_id: number;
  amount: number;
  type_id: number;
  transaction_date: string;
  name: string;
  destination_account_id?: number;
  category_id?: number;
  tag_id?: number;
  ticket_img?: string | null;
  description?: string;
  saving_plan_id?: number;
  saving_pocket_id?: number;
  installment_id?: number;
}

export const buildTransactionMutationPayload = (
  payload: TransactionMutationPayload,
): TransactionMutationPayload => {
  const normalizedPayload: TransactionMutationPayload = {
    account_id: payload.account_id,
    amount: payload.amount,
    type_id: payload.type_id,
    transaction_date: payload.transaction_date,
    name: payload.name.trim(),
  };

  if (payload.destination_account_id != null) normalizedPayload.destination_account_id = payload.destination_account_id;
  if (payload.category_id != null) normalizedPayload.category_id = payload.category_id;
  if (payload.tag_id != null) normalizedPayload.tag_id = payload.tag_id;
  if (payload.ticket_img === null) normalizedPayload.ticket_img = null;
  if (payload.ticket_img?.trim()) normalizedPayload.ticket_img = payload.ticket_img.trim();
  if (payload.description?.trim()) normalizedPayload.description = payload.description.trim();
  if (payload.saving_plan_id != null) normalizedPayload.saving_plan_id = payload.saving_plan_id;
  if (payload.saving_pocket_id != null) normalizedPayload.saving_pocket_id = payload.saving_pocket_id;
  if (payload.installment_id != null) normalizedPayload.installment_id = payload.installment_id;

  return normalizedPayload;
};

export const buildTransactionPatchPayload = (
  payload: Record<string, unknown>,
): Record<string, unknown> =>
  Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== undefined));

export const getTicketHref = (ticketImg?: string | null) => {
  const value = ticketImg?.trim();
  if (!value) return null;
  if (value.startsWith("http") || value.startsWith("data:")) return value;
  return `data:image/*;base64,${value}`;
};
